
import { defineComponent, computed } from 'vue';

export default defineComponent({
  props: {
    class: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      require: true,
      default: '',
    },
  },
  setup(props) {
    const className = computed(() => (props.class ? `svg-icon ${props.class}` : 'svg-icon'));
    const iconName = computed(() => `#icon-${props.icon}`);

    return {
      className,
      iconName,
    };
  },
});
